import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable, switchMap, take } from 'rxjs';
import { KnBrCartContextService } from 'src/feature-libs/kn-br-cart/base/core/facade/kn-br-cart-context.service';
import { KnBrOccCheckoutDeliveryAdapter } from 'src/feature-libs/kn-br-checkout/base/occ/adapters/kn-br-occ-checkout-delivery.adapter';
import { KnBrCustomerContextService } from 'src/store/kn-br-customer-context/kn-br-customer-context.service';

@Injectable({
  providedIn: 'root',
})
export class AtgCheckoutDeliveryAdapter extends KnBrOccCheckoutDeliveryAdapter {
  constructor(
    protected override http: HttpClient,
    protected override occEndpoints: OccEndpointsService,
    protected override converter: ConverterService,
    protected override customerContextService: KnBrCustomerContextService,
    private cartContextService: KnBrCartContextService
  ) {
    super(http, occEndpoints, converter, customerContextService);
  }

  setModeWithCollect(deliveryModeId: string, collectNumber?: string): Observable<any> {
    const params: Record<string, string> = { deliveryModeId };
    if (collectNumber) {
      collectNumber = collectNumber.toUpperCase();
      params['collectNumber'] = collectNumber;
    }
    return this.cartContextService.get$.pipe(
      take(1),
      switchMap((cartId) => {
        if (!cartId) {
          throw new Error('Cart ID is missing');
        }

        return this.http.put(
          this.getCartEndpoint('') + cartId + '/deliverymode',
          {},
          { params }
        );
      })
    );
  }
}
